import { Button, Flex, Stack, Icon } from "@chakra-ui/react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
    if (totalPages <= 0) return null;

    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);

    return (
        <Flex w="100%" justify="center" px="20px" pt="10px" mt="20px">
            <Stack direction="row" spacing="4px">
                {/* Previous Page Button */}
                <Button
                    onClick={() => onPageChange(currentPage - 1)}
                    isDisabled={currentPage === 1}
                    _hover={{ bg: "#ffc67b" }}
                    borderRadius="50%"
                >
                    <Icon as={MdChevronLeft} />
                </Button>

                {/* Page Numbers */}
                {Array.from({ length: Math.min(totalPages, 5) }, (_, index) => {
                    const page = startPage + index;
                    return page <= endPage ? (
                        <Button
                            key={page}
                            onClick={() => onPageChange(page)}
                            bg={page === currentPage ? "#fa8f03" : "transparent"}
                            color={page === currentPage ? "white" : "black"}
                            _hover={{ bg: page === currentPage ? "#f9b64c" : "#ffc67b" }}
                            borderRadius="50%"
                            isDisabled={page === currentPage}
                        >
                            {page}
                        </Button>
                    ) : null;
                })}

                {/* Next Page Button */}
                <Button
                    onClick={() => onPageChange(currentPage + 1)}
                    isDisabled={currentPage === totalPages}
                    borderRadius="50%"
                    _hover={{ bg: "#ffc67b" }}
                >
                    <Icon as={MdChevronRight} />
                </Button>
            </Stack>
        </Flex>
    );
};

export default Pagination;
